import { clearFilterParams } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../utils/apollo/api'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query ChecklistTypes($search: String, $filter: ChecklistTypeFilter) {
    checklistTypes(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

const SelectAllChecklistTypesLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={checklistsClient}
      {...props}
    />
  )
}

export default SelectAllChecklistTypesLink
